import React, { useState, useEffect, useRef } from "react"
import { graphql, useStaticQuery } from "gatsby"
import propTypes from "prop-types"

import { css } from "@emotion/react"
import { useBreakpoint } from "gatsby-plugin-breakpoints"
import { rgba } from "polished"
import { globalColors, fontSize } from "./css-functions"

import Img from "gatsby-image"

import { whichBrowser } from "./util-functions"

import Navigation from "./navigation"

import SvgHeaderBg from "../assets/svg/header_bg.svg"


const Header = ({
  title,
  bgData,
  subNavigation = null,
}) => {
  const bp = useBreakpoint()

  const [ titleClassName, setTitleClassName ] = useState([ "" ])

  const target = useRef(null)

  useEffect(() => {
    const browserFlags = whichBrowser()
    if ( browserFlags.isSafari ) {
      setTitleClassName([ "transformIsSafari" ])
    }
  }, [])

  const { allImageSharp } = useStaticQuery(graphql`
    query {
      allImageSharp {
        nodes {
          fluid(maxWidth: 1800) {
            originalName
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  const style ={
    header: css`
      width: 100%;
      height: ${ bp.isMiddle ? bp.isTablet ? '611px' : 'calc( 100vw * ( 1000 / 2096) )' : '250px' };
      display: flex;
      justify-content: center;
      position: relative;
    `,
    navWrapper: css`
      margin: 0 auto;
      width: 100%;
      position: fixed;
      top: 0;
      left: 50%;
      transform: translateX( -50% );
      background-color: ${ rgba(globalColors.gold, 0.8) };
      z-index: 2;
      transition: width 0.1s ease;
    `,
    titleWrapper: css`
      position: absolute;
      top: ${ bp.isTablet ? 'calc( 50% - 10% )' : 'calc( 50% - 5% )'};
      transform: translateY( -50% );
    `,
    title: css`
      writing-mode: vertical-rl;
      ${bp.isTablet ? fontSize(26) : fontSize(14)};
      color: ${globalColors.header};
      letter-spacing: 0.3em;
      &.transformIsSafari {
        transform: translate( -50% );
      }
    `,
    subNavWrapper: css`
      width: 100vw;
      position: absolute;
      bottom: ${ bp.isMiddle ? bp.isTablet ? bp.isPc ? '88px' : '120px' : 'calc( 100vw * ( 1000 / 2096 ) * 0.12 )' : '30px' };
      left: 50%;
      transform: translateX( -50% );
    `,
    svgHeaderBg: css`
      width: auto;
      height: 100%;
      position: absolute;
      top: 0;
      z-index: -1;
    `,
    headerPatternWrapper: css`
      position: absolute;
      width: ${ bgData.width };
      top: calc( 50% + ${ bgData.posOffset.y }px );
      left: calc( 50% + ${ bgData.posOffset.x }px );
      transform: translate( -50%, -50% );
      z-index: -1;
    `,
  }

  return (
    <header
      ref={ target }
      css={style.header}
    >
      <div css={style.navWrapper}>
        <Navigation />
      </div>
      <div css={style.titleWrapper}>
        <h1
          css={style.title}
          className={ titleClassName.join(" ") }
        >
          {title}
        </h1>
      </div>
      { subNavigation ?
        <div css={ style.subNavWrapper }>
          { subNavigation }
        </div>
        : ''
      }
      <SvgHeaderBg css={ style.svgHeaderBg } />
      { bgData.image &&
        <div css={ style.headerPatternWrapper }>
          <Img
            fluid={ allImageSharp.nodes.find(n => n.fluid.originalName === bgData.image).fluid }
            fadeIn={ false }
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      }
    </header>
  )
}

Header.propTypes = {
  title: propTypes.string,
  bgData: propTypes.object,
}

Header.defaultProps = {
  title: `[ ページタイトル ]`,
  bgData: {
    image: '',
    width: '0px',
    posOffset: {
      x: 0,
      y: 0,
    },
  },
}

export default Header